import { inject, Injectable } from '@angular/core';
import { DialogService } from '../../shared/services/dialog.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { InviteLearnerDto, Learner, LearnerDto } from '../models/learner.model';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LEARNER_FORM } from '../models/form/learner-form';
import { PayloadRequest, PayloadResponse, User, UserDto } from '../models';
import { ApiService, LocalStorageService } from '../../shared/services';
import { AuthService } from '../../auth/services/auth.service';
import { trimFormValues } from '../../shared/utils';

@Injectable({
  providedIn: 'root'
})
export class LearnerService {
  private apiService = inject(ApiService);
  private dialogService = inject(DialogService);
  private authService = inject(AuthService);
  

  constructor(
    private router: Router
  ) { }

  getLearnerFormInputs(): Observable<any> {
    return of(LEARNER_FORM);
  }

  loadLearnerData(id: number, form: FormGroup): Observable<any> {
    return this.getLearnerById(id).pipe(
      tap(res => {
        form.patchValue(res.data);
      })
    );
  }

  getLearnerById(learnerId: number): Observable<any> {
    return this.apiService.get(`learners/${learnerId}`).pipe(
      map(res => {
        return {
          ...res.data,
        }
      })
    );
  }

  getLastInsertedLearners(): Observable<Learner[]>{
    return this.apiService.get('learners/last-inserted').pipe(
      map(res => {
        return res.data
      })
    )
  }

  inviteLearner(inviteLearnerDto: InviteLearnerDto): Observable<PayloadResponse<Learner>> {
    const payload = new PayloadRequest<InviteLearnerDto>({ data: inviteLearnerDto });
    return this.apiService.post(`licenses/send-learner-invitation`, payload).pipe(
      catchError(error => {
        console.error('Error during learner invitation:', error);
        return of();
      })
    );
  }

  onSubmitForm(formLearner: FormGroup): Observable<PayloadResponse<Learner>> {
    trimFormValues(formLearner);

    if (formLearner.invalid) {
      formLearner.markAllAsTouched();
      this.dialogService.openDialogInfoNoRedirect('Errore', 'Compila tutti i campi obbligatori.');
      return of();
    }

    const learner = this.convertTypeForm(formLearner);
    return this.updateLearner(learner).pipe(
      tap(() => this.showDialogSuccess())
    );
  }
  
  updateLearner(client: LearnerDto): Observable<PayloadResponse<Learner>> {
    const payload = new PayloadRequest<LearnerDto>({ data: client });
    return this.apiService.patch(`learners/update`, payload);
  }

  private showDialogSuccess(): void {
    const dialogMessage = 'Il discente è stato modificato con successo';

    this.dialogService.openDialogAlert('Operazione completata', dialogMessage, () => {
      this.router.navigate(['/main/discenti']);
    });
  }

  convertTypeForm(form: FormGroup): LearnerDto {
    const learner: LearnerDto = {
      learnerId: form.value.learnerId,
      name: form.value.name,
      surname: form.value.surname,
      email: form.value.email,
      fiscalCode: form.value.fiscalCode,
      birthDate: form.value.birthDate,
      birthPlaceId: Number(form.value.birthPlaceId),
    }
    return learner;
  }

  navigateToList(): void {
    this.router.navigate(['/main/discenti']);
  }

   toggleLearnerStatus(learnerFiscalCode: string): Observable<PayloadResponse<User>> {
    const userDto: UserDto = {
      username: learnerFiscalCode
    }
    const payload = new PayloadRequest<UserDto>({ data: userDto });
    return this.apiService.patch(`user/update-status`, payload);
  }

    loginAsLearner(learnerFiscalCode: string) {
    const userDto: UserDto = { username: learnerFiscalCode };
    const payload = new PayloadRequest<UserDto>({ data: userDto });
    return this.apiService.post(`learners/login-learner-dashboard`, payload).pipe(
      tap((res) => {
        this.authService.logout()
        this.authService.setCurrentUserAndTokenLocalStorage(res.data);
        this.router.navigate(['auth/login']);
    })
    );
  }

  deleteLicense(licenseId: number) {
    return this.apiService.delete(`licenses/delete/${licenseId}`);
  }
}